// @systeme: interface
// Un texte légal (CGU, CGV, confidentialité) : public, lisible avant d'avoir un compte.
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as LienRouteur } from 'react-router';
import type { CleJuridique, TexteJuridique } from '@foyer/shared';
import { Chargement } from '../composants/Chargement';
import { TexteRiche } from '../composants/TexteRiche';
import { api } from '../lib/api';
import { tailles } from '../theme/theme';

export function Juridique({ cle }: { cle: CleJuridique }) {
  const [texte, setTexte] = useState<TexteJuridique | undefined>();
  const [absent, setAbsent] = useState(false);

  useEffect(() => {
    api.juridique
      .lire(cle)
      .then(setTexte)
      .catch(() => setAbsent(true));
  }, [cle]);

  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', px: `${tailles.marge}px`, pt: 4, pb: 6 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        <LienRouteur to="/" style={{ color: 'inherit' }}>
          ← Foyer
        </LienRouteur>
      </Typography>
      {absent ? (
        <Typography>Ce texte n’existe pas.</Typography>
      ) : !texte ? (
        <Chargement />
      ) : (
        <>
          <Typography variant="h1" component="h1" gutterBottom>
            {texte.titre}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Version du {texte.version}
          </Typography>
          <TexteRiche texte={texte.contenu} />
        </>
      )}
    </Box>
  );
}
